import { Injectable } from '@angular/core';

import { StoreServiceLibrary } from '../store/store.service';
import { keysUniversal } from '../../resources/keys.resources';

import * as CryptoJS from 'crypto-js';
import * as moment_ from 'moment';
import { GeneralUtilService } from '../general-util/generalUtil.service';

const moment = moment_;

// https://vike.io/es/409095/
@Injectable({
  providedIn: 'root'
})
export class CryptoService {

  keySize = 256;
  // ivSize = 128;
  // iterations = 100;

  // message = 'Hello World';
  // password = 'Secret Password';

  constructor(
    private store: StoreServiceLibrary,
    private generalUtil: GeneralUtilService
  ) { }

  encrypt(msg, pass, UUID, isJWT = false) {
    let ivSalt = '';
    if (isJWT) {
      ivSalt = this.generateSaltForJwt(UUID);
    } else {
      ivSalt = this.generateSalt(UUID);
    }
    // let secretkey = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ123456'; //Length 32
    let secretkey = pass; //Length 32
    let key = CryptoJS.enc.Utf8.parse(secretkey);
    // let iv = CryptoJS.enc.Utf8.parse(secretkey.substring(0, 16));
    let iv = CryptoJS.enc.Utf8.parse(ivSalt);
    let cipherText = CryptoJS.AES.encrypt(msg, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }).toString();
    return cipherText;
  }

  decrypt(transitmessage, pass, UUID, isJWT = false) {
    let ivSalt = '';
    if (isJWT) {
      ivSalt = this.generateSaltForJwt(UUID);
    } else {
      ivSalt = this.generateSalt(UUID);
    }
    // let secretkey = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ123456'; //Length 32
    let secretkey = pass; //Length 32
    let key = CryptoJS.enc.Utf8.parse(secretkey);
    // let iv = CryptoJS.enc.Utf8.parse(secretkey.substring(0, 16));
    let iv = CryptoJS.enc.Utf8.parse(ivSalt);
    let decrypted = CryptoJS.AES.decrypt(transitmessage, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  generateSalt(UUID): string {
    let date = this.generalUtil.getLocalDate();
    const dayOfMonth = date.getDate();
    const ispair: boolean = dayOfMonth % 2 === 0;
    let iv;
    if (ispair) {
      iv = UUID.substring(0, (UUID.length / 4)) + UUID.substring((UUID.length / 4) * 3, UUID.length);
    } else {
      iv = UUID.substring((UUID.length / 4), (UUID.length / 4) * 3);
    }
    return iv;
  }

  generateSaltForJwt(UUID): string {
    let date = this.generalUtil.getLocalDate();
    const dayOfMonth = date.getDate();
    const ispair: boolean = dayOfMonth % 2 === 0;
    let iv;
    if (ispair) {
      iv = UUID.substring(0, (UUID.length / 4)) + UUID.substring((UUID.length / 4) * 3, UUID.length);
    } else {
      iv = UUID.substring((UUID.length / 4), (UUID.length / 4) * 3);
    }
    return iv;
  }

  create_UUID() {
    let dt = this.generalUtil.getLocalDate();
    dt = dt.getTime();
    let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      let r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
  }

  convertResponse(response, isJwt = false, isUniversal = false, pass = '') {
    let passResponse = this.store.getJustOneUniversalPropertie(keysUniversal.APP_VALIDATION_RES);
    let dateUser = this.generalUtil.getLocalDate();

    if (isUniversal) {
      passResponse = this.generatePassUniversal(pass, false, dateUser);
    }

    let contentResponse;

    if (response && response?.content) {
      contentResponse = atob(response.content);

      if (isJwt) {
        contentResponse = contentResponse.substring(16, contentResponse.length);
      } else {
        contentResponse = contentResponse.substring(32, contentResponse.length);
      }

      let contentResponseArr = contentResponse.split('===');
      let iv = contentResponseArr[0];
      let content = contentResponseArr[1];
      let respDecrypt = this.decrypt(content, passResponse, iv, isJwt);
      return respDecrypt;
    } else {
      return 'false';
    }

  }

  generateRequest(request, isJwt = false, isUniversal = false, pass = '') {
    let passRequest = this.store.getJustOneUniversalPropertie(keysUniversal.APP_VALIDATION_REQ);

    let dateUser = this.generalUtil.getLocalDate();
    if (isUniversal) {
      passRequest = this.generatePassUniversal(pass, true, dateUser);
    }

    let UUID = this.create_UUID();

    let UUIDM5 = this.create_UUID();

    UUID = UUID.replace(/-/ig, '');
    UUIDM5 = UUIDM5.replace(/-/ig, '');

    let MD5 = CryptoJS.MD5(UUIDM5).toString();

    if (isJwt) {
      MD5 = MD5.substring(0, 16);
    }

    let content = this.encrypt(JSON.stringify(request), passRequest, UUID, isJwt)

    return btoa(`${MD5}${UUID}===${content}`);
  }

  decryptedUniversal(transitmessage, pass, iv) {
    const salt = iv;

    const date = this.generalUtil.getLocalDate();
    const dayOfMonth = date.getDate();
    const ispair: boolean = dayOfMonth % 2 === 0;
    let saltModifier;
    if (ispair) {
      saltModifier = salt.substring(0, (salt.length / 4)) + salt.substring((salt.length / 4) * 3, salt.length);
    } else {
      saltModifier = salt.substring((salt.length / 4), (salt.length / 4) * 3);
    }

    const secretFinal = CryptoJS.enc.Utf8.parse(pass);
    const ivFinal = CryptoJS.enc.Utf8.parse(saltModifier);
    const decrypted = CryptoJS.AES.decrypt(transitmessage, secretFinal, {
      keySize: 128 / 8,
      iv: ivFinal,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
  }

  generatePassUniversal(pass, isReq, day) {
    const year = moment(day).format('YYYY');
    let month = moment(day).format('MM-DD');
    let newP = '';
    if (day.getDate() % 2 == 0) {
      if (isReq) {
        month = moment(day).format('MM/DD');
        newP = `${year}/${pass}${month}`;
      } else {
        month = moment(day).format('MM/DD');
        newP = `${month}${pass}${year}/`;
      }
    } else {
      if (isReq) {
        newP = `${year}-${pass}${month}`;
      } else {
        newP = `${month}${pass}${year}-`;
      }
    }
    return newP;
  }

  decryptCard(transitmessage, pass, iv) {
    const salt = iv;
    const date = new Date();
    const dayOfMonth = date.getDate();
    const ispair: boolean = dayOfMonth % 2 === 0;
    let saltModifier;
    if (ispair) {
      saltModifier = salt.substring(0, (salt.length / 4)) + salt.substring((salt.length / 4) * 3, salt.length);
    } else {
      saltModifier = salt.substring((salt.length / 4), (salt.length / 4) * 3);
    }

    const msg = transitmessage;
    const keySecret = pass;

    const msgFinal = CryptoJS.enc.Base64.parse(msg);
    const secretFinal = CryptoJS.enc.Utf8.parse(CryptoJS.SHA1(keySecret).toString().substring(0, 16));
    const ivFinal = CryptoJS.enc.Hex.parse(this.encodeToHex(saltModifier));
    const result = CryptoJS.AES.decrypt(
      {
        ciphertext: msgFinal
      },
      secretFinal,
      {
        iv: ivFinal,
      }).toString(CryptoJS.enc.Utf8);

    return result;
  }

  encodeToHex(str) {
    let result = '';
    for (let i = 0; i < str.length; i++) {
      result += str.charCodeAt(i).toString(16);
    }
    return result;
  }
}
